<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.guards') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <i class="fa fa-shield"></i>
          <span>{{ $ml.get('shared.guardTourSystem') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.guards') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-3">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{ $ml.get('guardTour.guards') }}</span>
              </h3>
              <div class="box-tools pull-right">
                <button type="button" class="btn btn-sm btn-warning " @click="newGuard()">{{$ml.get('guardTour.newGuard')}}</button>
              </div>
            </div>
            <div class="box-body">
              <input type="text" :placeholder="$ml.get('general.search')" v-model="searchText" class="form-control"
                style="margin-bottom:10px;" autocomplete="false" />
              <div v-show="guardList.length > 0" class="table-responsive no-padding" :style="windowHeightSize">
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="guard in guardList" :key="guard.id">
                      <td>
                        {{ guard.name }}
                        <span v-show="guard.title != ''">({{ guard.title }})</span>
                      </td>
                      <td class="pull-right">
                        <button type="button" class="btn btn-primary btn-sm" @click="getGuard(guard.id)">
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="guardList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{ $ml.get('users.userNotRecord') }}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{ $ml.get('guardTour.guardInfo') }}</span>
              </h3>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-4" align="center">
                  <img
                    :src="(this.guard.image == null && this.tempUrl == null) || (this.guard.image == '' && this.tempUrl == null) ? '/src/assets/default-user.png' : this.guard.image || this.tempUrl"
                    class="profile-user-img img-responsive img-circle" style="height: 150px; width: 150px;" />
                  <a href="#" v-show="this.tempUrl || this.guard.image" @click="removeImage()" class="text-red">
                    <i class="fa fa-remove"></i>
                    {{ $ml.get('general.remove') }}
                  </a>
                  <hr />
                  <my-upload field="img" @crop-success="cropSuccess" langType="tr" v-model="showImageDialog"
                    :width="300" :height="300" url="/images" :params="params" :headers="headers"
                    img-format="png"></my-upload>
                  <button type="button" @click="toggleShow()" class="btn btn-primary btn-sm" style="width:100%">
                    <i class="fa fa-upload"></i>
                    {{ $ml.get('users.selectPhoto') }}
                  </button>
                </div>
                <div class="col-sm-8">
                  <div class="form-group">
                    <label>{{ $ml.get('guardTour.nameSurname') }}</label>
                    <input v-model="guard.name" type="text" class="form-control" />
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('guardTour.title') }}</label>
                    <input v-model="guard.title" type="text" class="form-control" />
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('users.email') }}</label>
                    <input v-model="guard.mail" type="text" class="form-control" autocomplete="false"
                      aria-autocomplete="false" />
                  </div>
                </div>
                <div class="col-sm-12">
                  <hr />
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>{{ $ml.get('users.phoneNumber') }}</label>
                        <input v-model="guard.phone" type="text" class="form-control" placeholder />
                      </div>
                      <button data-toggle="modal" data-target="#modal-parola-guncelle" class="btn btn-primary"
                        style="width:100%;">
                        <i class="fa fa-key"></i> {{ $ml.get('guardTour.updatePassword') }}
                      </button>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>{{ $ml.get('employees.mobileBrand') }}</label>
                        <label class="form-control" v-if="guard.mobilUID"><i class="fa fa-link"></i> <span
                            v-text="guard.mobileToken ? guard.mobileToken : $ml.get('employees.unknown')"></span></label>
                        <label class="form-control" v-else>{{ $ml.get('employees.notPaired') }}</label>
                      </div>
                      <button class="btn btn-danger" @click="removePhonePair()" :disabled="!guard.mobilUID"
                        style="width:100%;"><i class="fa fa-ban"></i> {{
                          $ml.get('employees.resetPairing') }}</button>
                    </div>
                  </div>
                  <hr />
                </div>
                <div class="col-sm-12">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h3 class="box-title">
                        <span>{{ $ml.get('guardTour.responsibleUserForGuard') }}</span>
                      </h3>
                    </div>
                    <div class="box-body">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group" style="margin-left: 20px;">
                            <div v-for="user in userList" :key="user.id" class="checkbox" style="margin:5px">
                              <label>
                                <input type="checkbox" :value="user.id" v-model="guard.authorizedUserIds" />
                                {{ user.name }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="overlay" :hidden="!isLoadingDetail">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div class="box-footer">
                <div class="pull-left">
                  <button v-show="!isNewGuard" type="button" data-toggle="modal" data-target="#modal-sil"
                    class="btn btn-danger" style="margin: 5px; width:120px;">{{ $ml.get('general.delete')
                    }}</button>
                </div>
                <div class="pull-right">
                  <button v-show="isNewGuard" type="button" data-toggle="modal" data-target="#modal-kaydet"
                    class="btn btn-success " style="margin: 5px; width:120px;">{{ $ml.get('general.save')
                    }}</button>
                  <button v-show="!isNewGuard" type="button" data-toggle="modal" data-target="#modal-guncelle"
                    class="btn btn-success " style="margin: 5px; width:120px;">{{ $ml.get('general.update')
                    }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <!--GÜNLER-->
          <h4>{{ $ml.get('guardTour.tourCalendar') }}</h4>
          <div v-for="day in dayList" :key="day.value" class="box box-primary collapsed-box" :id="'day' + day.value">
            <div @click="onCloseBoxDevice('day' + day.value)" class="box-header with-border" style="cursor:pointer;">
              <i class="fa fa-calendar"></i>
              <h3 class="box-title">
                <span>{{ day.name }}</span>
                <span class="badge label-primary">{{ getCalendar(day.value).length }}</span>
              </h3>
              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="box-body">
              <ul>
                <li v-for="cal in getCalendar(day.value)" :key="cal.id">
                  <span style="cursor:pointer;" @click="selectCalendar(cal)">{{ getGuardTourFromId(cal.tourId).name
                    }}</span>
                  <button @click="deleteCalendar(cal.id)" class="btn btn-xs btn-danger">
                    <i class="fa fa-times"></i>
                  </button>
                </li>
              </ul>
              <button v-show="!isNewGuard" @click="newCalendar(day.value)" data-toggle="modal" data-target="#modal-tour"
                class="btn btn-xs btn-warning" style="width:100%;">
                <i class="fa fa-plus"></i> {{ $ml.get('guardTour.newCalendar') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-parola-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>Parola Güncelle</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <div class="form-group">
                  <label>{{ $ml.get('users.password') }}</label>
                  <input v-model="guard.password" type="password" autocomplete="false" aria-autocomplete="false"
                    class="form-control" />
                </div>
                <div class="form-group">
                  <label>{{ $ml.get('users.repeatPassword') }}</label>
                  <input v-model="guard.password2" type="password" class="form-control" />
                </div>
              </div>
              <br />
              <p></p>
              <span>Parola güncellenecektir. Devam edilsin mi?</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="updatePassword()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.update') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ guard.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('users.isContinueUserUpdate') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveGuard()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.save') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{ guard.name }}</p>
              <span>{{ $ml.get('users.isContinueUserSave') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveGuard()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{ $ml.get('general.save') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.delete') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ guard.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('users.isContinueUserDelete') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click.prevent="deleteGuard()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal fade" id="modal-tour">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>Tur Takvimi</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group" style="margin-top:10px;">
                    <label>
                      <i class="fa fa-flag-checkered"></i> Tur
                    </label>
                    <select @change="changeTour($event)" class="form-control">
                      <option value="">{{ $ml.get('general.select') }}</option>
                      <option v-for="gt in guardTourList" :key="gt.id" :value="gt.id"
                        :selected="calendar.tourId == gt.id">{{ gt.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="pull-left">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $ml.get('general.cancel')
                  }}</button>
              </div>
              <div class="pull-right">
                <button data-dismiss="modal" v-show="!isNewTour" @click="deleteCalendar(calendar.id)"
                  class="btn btn-danger ">
                  <i class="fa fa-trash"></i>
                  {{ $ml.get('general.delete') }}
                </button>
                <button data-dismiss="modal" v-show="!isNewTour" @click="saveCalendar()" class="btn btn-success ">
                  <i class="fa fa-refresh"></i>
                  {{ $ml.get('general.update') }}
                </button>
                <button data-dismiss="modal" v-show="isNewTour" @click="saveCalendar()" class="btn btn-success ">
                  <i class="fa fa-check"></i>
                  {{ $ml.get('general.save') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
    </section>
  </div>
</template>
<script>
import myUpload from "vue-image-crop-upload";
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      users: [],
      guard: {
        id: 1,
        name: "",
        title: "",
        mail: "",
        password: "",
        password2: "",
        phone: "",
        image: null,
        authorizedUserIds: []
      },
      isNewGuard: true,
      guards: [],
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      params: {},
      headers: {},
      days: [
        { value: 1, name: this.$ml.get("general.monday"), check: true },
        { value: 2, name: this.$ml.get("general.tuesday"), check: true },
        { value: 3, name: this.$ml.get("general.wednesday"), check: true },
        { value: 4, name: this.$ml.get("general.thursday"), check: true },
        { value: 5, name: this.$ml.get("general.friday"), check: true },
        { value: 6, name: this.$ml.get("general.saturday"), check: true },
        { value: 7, name: this.$ml.get("general.sunday"), check: true }
      ],
      isNewTour: true,
      calendar: {
        id: null,
        guardId: null,
        tourId: null,
        day: 1
      },
      calendars: [],
      guardTours: []
    };
  },
  components: {
    "my-upload": myUpload
  },
  computed: {
    authControl() {
      return this.$store.getters.getAuthBekciTur;
    },
    modules() {
      return this.$store.getters.getModules;
    },
    guardList() {
      if (this.searchText) {
        return this.guards.filter(item => {
          return this.searchText
            .toUpperCase()
            .split(" ")
            .every(v => item.name.toUpperCase().includes(v));
        });
      } else {
        return this.guards;
      }
    },
    userList() {
      return this.users;
    },
    guardTourList() {
      return this.guardTours;
    },
    dayList() {
      return this.days;
    },
    calendarList() {
      return this.calendars;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    toggleShow() {
      this.showImageDialog = !this.showImageDialog;
    },
    cropSuccess(imgDataUrl, imgData, mime, field) {
      this.imageData = imgData;
      this.tempUrl = imgDataUrl;
      this.showImageDialog = false;
    },
    removeImage() {
      this.imageData = null;
      this.tempUrl = null;
      this.guard.image = null;
    },
    onCloseBoxDevice(day) {
      $("#" + day).boxWidget("toggle");
    },
    newGuard() {
      this.isLoadingDetail = true;
      this.isNewGuard = true;
      this.guard.id = null;
      this.guard.name = "";
      this.guard.title = "";
      this.guard.mail = "";
      this.guard.password = "";
      this.guard.password2 = "";
      this.guard.image = null;
      this.guard.phone = "";
      this.imageData = null;
      this.tempUrl = null;
      this.calendars = [];
      this.guard.authorizedUserIds = [];
      this.isLoadingDetail = false;
    },
    async deleteGuard() {
      if (this.guard.id == null) {
        alertify.warning("Lütfen önce görevli seçin...");
        return;
      }
      try {
        this.isLoadingDetail = true;
        let id = this.guard.id;
        const response = await this.$axios
          .delete("/GuardDefinition/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getGuards();
        this.newGuard();
        alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async updatePassword() {
      if (this.guard.id == null) {
        alertify.warning("Lütfen önce görevli seçin...");
        return;
      }
      if (this.guard.password != this.guard.password2) {
        alertify.warning(this.$ml.get("alerts.passwordsDoNotMatch"));
        return;
      }
      if (this.guard.password == "") {
        alertify.warning(this.$ml.get("alerts.pleaseEnterAPassword"));
        return;
      }
      try {
        this.isLoadingDetail = true;
        const response = await this.$axios
          .post("/GuardDefinition/UpdatePassword/", {
            guardId: this.guard.id,
            password: this.guard.password
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
            }
          })
          .catch(doc => {
            if (doc.status == 401) {
              this.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(this.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        this.isLoadingDetail = false;
      } catch (ex) {
        console.error(error);
        alertify.error(error);
        this.isLoadingDetail = false;
      }
    },
    async saveGuard() {
      if (this.guard.name == "") {
        alertify.warning(this.$ml.get("alerts.pleaseEnterAUserName"));
        return;
      }

      this.isLoadingDetail = true;
      if (this.isNewGuard) {
        try {
          let guard2 = this.guard;
          let image = this.imageData;
          const response = await this.$axios
            .post("/GuardDefinition", {
              name: guard2.name,
              title: guard2.title,
              mail: guard2.mail,
              phone: guard2.phone,
              authorizedUserIds: guard2.authorizedUserIds
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = response.data.id;
          if (this.imageData) {
            const formData = new FormData();
            formData.append("file", image);
            if (this.imageData != null) {
              const responseImage = await this.$axios.post(
                "/GuardDefinition/AddGuardPhoto/" + id,
                formData
              );
            }
          }
          try {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
            } else {
              alertify.error(response.message);
            }
          } catch (error) { }
          this.getGuards();
          this.getGuard(id);
          this.isNewGuard = false;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let guard2 = this.guard;
          let image = this.imageData;
          const response = await this.$axios
            .put("/GuardDefinition/" + guard2.id, {
              name: guard2.name,
              title: guard2.title,
              mail: guard2.mail,
              phone: guard2.phone,
              authorizedUserIds: guard2.authorizedUserIds
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = guard2.id;
          if (this.imageData) {
            const formData = new FormData();
            formData.append("file", image);
            const responseImage = await this.$axios.post(
              "/GuardDefinition/AddGuardPhoto/" + id,
              formData
            );
          } else if (this.guard.image == null) {
            const responseImage = await this.$axios.patch(
              "/GuardDefinition/RemovePhoto/" + id
            );
          }
          try {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
            } else {
              alertify.error(response.message);
            }
          } catch (error) { }
          this.getGuards();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    removePhonePair() {
      try {
        let id = this.guard.id;
        if (id != null) {
          const response = this.$axios
            .delete("/GuardDefinition/ResetPair/" + id)
            .then(response => {
              alertify.success("Başarıyla Sıfırlandı!");
              this.getGuard(id);
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    async getGuard(id) {
      try {
        this.isLoadingDetail = true;
        this.newGuard();
        const response = await this.$axios
          .get("/GuardDefinition/" + id)
          .then(response => {
            this.isNewGuard = false;
            this.guard.id = id;
            this.guard.name = response.data.name;
            this.guard.title = response.data.title;
            this.guard.mail = response.data.mail;
            this.guard.phone = response.data.phone;
            this.guard.image = response.data.image;
            this.guard.authorizedUserIds = response.data.authorizedUserIds;
            this.guard.mobilUID = response.data.mobilUID;
            this.guard.mobileToken = response.data.mobileToken;
            this.getGuardCalendar(id);
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    getCalendar(day) {
      return this.calendarList.filter(item => {
        return item.day == day;
      });
    },
    getGuardTourFromId(id) {
      var tour = this.guardTourList.filter(item => {
        return item.id == id;
      });
      if (tour[0]) {
        return tour[0];
      } else {
        return "";
      }
    },
    changeTour(event) {
      this.calendar.tourId = event.target.value;
    },
    newCalendar(day) {
      this.isNewTour = true;
      this.calendar.id = null;
      this.calendar.guardId = this.guard.id;
      this.calendar.tourId = null;
      this.calendar.day = day;
    },
    selectCalendar(calendar) {
      this.isNewTour = false;
      this.calendar.id = calendar.id;
      this.calendar.guardId = calendar.guardId;
      this.calendar.tourId = calendar.tourId;
      this.calendar.day = calendar.day;
      $("#modal-tour").modal("show");
    },
    async deleteCalendar(tourId) {
      try {
        this.isLoadingDetail = true;
        let id = tourId;
        const response = await this.$axios
          .delete("/GuardCalendar/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getGuardCalendar(this.guard.id);
        alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async saveCalendar() {
      console.log(this.calendar);
      if (this.calendar.tourId == null || this.calendar.tourId == "") {
        alertify.warning("Lütfen tur seçin...");
        return;
      }
      this.isLoadingDetail = true;
      if (this.isNewTour) {
        try {
          let calendar2 = this.calendar;
          const response = await this.$axios
            .post("/GuardCalendar", {
              guardId: calendar2.guardId,
              tourId: calendar2.tourId,
              day: calendar2.day
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get("alerts.savedSuccessfully"));
          } else {
            alertify.error(response.message);
          }
          this.getGuardCalendar(this.guard.id);
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let calendar2 = this.calendar;
          let image = this.imageData;
          const response = await this.$axios
            .put("/GuardCalendar/" + calendar2.id, {
              guardId: calendar2.guardId,
              tourId: calendar2.tourId,
              day: calendar2.day
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          try {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
            } else {
              alertify.error(response.message);
            }
          } catch (error) { }
          this.getGuardCalendar(this.guard.id);
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async getGuardCalendar(id) {
      try {
        this.isLoadingDetail = true;
        var calendars = [];
        const response = await this.$axios
          .get("/GuardCalendar?guardId=" + id)
          .then(response => {
            response.data.forEach(doc => {
              calendars.push({
                id: doc.id,
                guardId: doc.guardId,
                tourId: doc.tourId,
                day: doc.day
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.calendars = calendars;
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async getGuards() {
      try {
        this.isLoading = true;
        const guards = [];
        const response = await this.$axios
          .get("/GuardDefinition")
          .then(response => {
            response.data.forEach(doc => {
              guards.push({
                id: doc.id,
                name: doc.name,
                title: doc.title
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.guards = guards;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getGuardTours() {
      try {
        this.isLoading = true;
        const guardTours = [];
        const response = await this.$axios
          .get("/GuardTour")
          .then(response => {
            response.data.forEach(doc => {
              guardTours.push({
                id: doc.id,
                name: doc.name,
                startDate: doc.startDate
                  ? this.toDateFormat(doc.startDate, "ss:dd")
                  : "",
                endDate: doc.endDate
                  ? this.toDateFormat(doc.endDate, "ss:dd")
                  : ""
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.guardTours = guardTours;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getUsers() {
      try {
        this.isLoading = true;
        const users = [];
        const response = await this.$axios
          .get("/User")
          .then(response => {
            response.data.forEach(doc => {
              users.push({
                id: doc.id,
                name: doc.name,
                title: doc.title,
                isChecked: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.users = users;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getUsers();
    await this.getGuards();
    await this.getGuardTours();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/guardTour/Guards.vue